import { createPortal } from "react-dom";
import AddressSearch from "./AddressSearch";
import type { SearchAreaType } from "^/customer/home/useStoreSearch";

export interface PostcodeResult {
  address: string;
  zonecode: string;
  roadAddress: string;
  jibunAddress: string;
  buildingName?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  onSelect: (result: PostcodeResult) => void;
}

export default function DaumPostcodeModal({ open, onClose, onSelect }: Props) {
  if (!open) return null;

  const handleSelect = (selected: SearchAreaType) => {
    const roadAddress = selected.road_address?.address_name ?? "";
    const jibunAddress = selected.address?.address_name ?? selected.address_name ?? "";
    const address = roadAddress || jibunAddress;

    onSelect({
      address,
      zonecode: selected.road_address?.zone_no ?? "",
      roadAddress,
      jibunAddress,
      buildingName: selected.road_address?.building_name,
    });
    onClose();
  };

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center bg-black/45 px-4"
      style={{ zIndex: 10000 }}
      onClick={onClose}
    >
      <div
        className="flex max-h-[82vh] w-full max-w-[480px] flex-col rounded-2xl bg-white shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-[#EEE] px-4 py-3">
          <h3 className="text-[15px] font-bold text-[#111]">주소 검색</h3>
          <button
            type="button"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded text-[22px] leading-none text-[#666] hover:bg-[#F5F5F5]"
            aria-label="닫기"
          >
            ×
          </button>
        </div>

        <div className="min-h-[260px] flex-1 overflow-visible px-4 py-4">
          <AddressSearch
            onSelect={handleSelect}
            className="[&_ul]:z-[10001] [&_ul]:max-h-[52vh]"
          />
          <p className="mt-3 text-[12px] leading-relaxed text-[#777]">
            도로명 또는 지번 주소를 입력하고 검색 결과를 선택해 주세요.
          </p>
        </div>
      </div>
    </div>,
    document.body,
  );
}
